'use client'

import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex flex-col items-center justify-center gap-6 text-center"
          style={{ minHeight: '50vh', padding: '2rem' }}
        >
          <svg width="32" height="32" viewBox="0 0 100 100" fill="none">
            <polygon
              points="50,5 89,27.5 89,72.5 50,95 11,72.5 11,27.5"
              stroke="var(--color-fire)"
              strokeWidth="6"
              fill="none"
            />
          </svg>
          <p
            className="font-mono uppercase"
            style={{ fontSize: '0.75rem', letterSpacing: '0.2em', color: 'var(--color-fog)' }}
          >
            Something went wrong
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="font-mono uppercase"
            style={{
              fontSize: '0.65rem',
              letterSpacing: '0.15em',
              color: 'var(--color-fire)',
              background: 'rgba(255,107,0,0.08)',
              border: '1px solid rgba(255,107,0,0.2)',
              padding: '0.5rem 1.5rem',
              borderRadius: '3px',
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
